import { Flex } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";
import { theme } from "src/theme";

function CategoryTreeSkeleton(): JSX.Element {
  return (
    <Flex as="ul" flexDirection="column" gap={theme.space.space16}>
      {[...(Array(10) as number[])].map((_, index) => (
        <Flex as="li" key={`skeleton-line-${index}`} gap={theme.space.space16}>
          <Skeleton width="100vw" height={theme.space.space24} />
        </Flex>
      ))}
    </Flex>
  );
}

export { CategoryTreeSkeleton };
